const isConvertionNeeded = (amount: number, from: string, to: string) =>
  amount > 0 && from !== to;

export default isConvertionNeeded;
